<template>
	<ul v-if="socials && socials.length" class="social-links">
		<li v-for="({ media, follow_link, follow_url }, k) in socials" :key="k">
			<a ref="nofollow noopener" :href="follow_link || follow_url" target="_blank" :title="'Følg oss ' + media">
				<span class="icon" v-html="socialIcon(media)"></span>
			</a>
		</li>
	</ul>
</template>

<script>
import icons from '@/icons'

export default {
	props: {
		socials: Array,
		color: {
			type: String,
			default: '#222831',
		},
	},
	methods: {
		socialIcon(media) {
			let icon = media
			const color = this.color

			switch (media) {
				case 'facebook':
					icon = icons.facebook(color)
					break
				case 'instagram':
					icon = icons.instagram(color)
					break
				case 'snapchat':
					icon = icons.snapchat(color)
					break
				case 'twitter':
					icon = icons.twitter(color)
					break
				case 'youtube':
					icon = icons.youtube(color)
					break
				case 'soundcloud':
					icon = icons.soundcloud(color)
					break
				case 'spotify':
					icon = icons.spotify(color)
					break
				case 'tiktok':
					icon = icons.tiktok(color)
					break
				case 'home':
					icon = icons.home(color)
					break
				case 'linkedin':
					icon = icons.linkedin(color)
					break
			}
			return icon
		},
	},
}
</script>

<style lang="scss">
.social-links {
	margin: 0;
	padding: 0;
	list-style: none;
	li {
		display: inline-block;
		margin-right: 25px;
		&:last-child {
			margin-right: 0;
		}
		a {
			cursor: pointer;
			display: inline-flex;
			border-radius: 50px;
			background: #fff;
			width: 50px;
			height: 50px;
			align-items: center;
			justify-content: center;
			transition: all 0.2s ease-in-out;
			span,
			svg {
				line-height: 1;
			}
			&:hover {
				background: var(--dark);
				box-shadow: 0 0 0 2px #fff;
				svg {
					path {
						fill: #fff;
					}
				}
			}
		}
		svg {
			height: 25px;
			path {
				transition: fill 0.2s ease-in-out;
			}
		}
	}
}
</style>
